import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Layout } from '.';

import { Date, Progress } from '../components';

@inject('SaleStore') @observer
export default class SaleList extends Component {
  
  componentWillMount() {
    const { SaleStore } = this.props;
    SaleStore.fetch();
  }

  render() {
    const { SaleStore } = this.props;
    return (
      <Layout footerStyle={{backgroundColor: '#FFF'}}>
        <section className="novidades listagem">
          { SaleStore.isLoading && <Progress /> }

          { !SaleStore.isLoading &&
            <section className="main">
              <div className="noticias-filtro">
              { SaleStore.categories.length > 0 && (
                <ul className="categorias-noticias">
                  <li>
                    <button className={!SaleStore.categoryId ? 'active' : ''} onClick={() => SaleStore.clearFilterCategory()}>Todas</button>
                  </li>
                  { SaleStore.categories.map((category) => (
                    <li key={`category-${category.id}`}>
                      <button className={SaleStore.categoryId === category.id ? 'active' : ''} onClick={() => SaleStore.filterCategory(category.id)}>{category.name}</button>
                    </li>
                  ))}
                </ul>
              )} 

              { SaleStore.categories.length === 0 && (
                <p className="no-results">Não há combos e ofertas cadastrados até o momento.</p>
              )}
              </div>

              <ul className="ofertas-listagem">
                {SaleStore.sales.map((sale) => (
                  <li key={`sale-${sale.id}`}>
                    <Link to={`/ofertas-e-combos/${sale.slug}`} title={sale.name}>
                      <div className="image">
                        <img src={sale.image} alt={sale.name} />
                      </div>

                      <div className="content">
                        <Date date={sale.date} />
                        <span className="title">{sale.name}</span>
                        <button>Veja mais</button>
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            </section>
          }
        </section>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/SaleList.js